import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { StoryBlokService } from '../service/storyblok.service';
import { ThemeService } from '../service/theme.service';
import { ResolverErrorService } from './resolver-error.service';

@Injectable({ providedIn: 'root' })
export class StoryblokBlogParentResolver implements Resolve<any> {
  constructor(
    private storyBlokService: StoryBlokService,
    private themeService: ThemeService,
    private resolverError: ResolverErrorService
  ) {}

  async resolve(route: ActivatedRouteSnapshot) {
    const urlSegments = route.url.map((segment) => segment.path).join('/');

    const storyPath = urlSegments;

    const articles = await this.storyBlokService.getStories({
      content_type: 'article',
      starts_with: storyPath,
      sort_by: 'published_at:desc',
    });

    return {
      ...(await this.storyBlokService
        .getStory(storyPath, {})
        .then((result) => {
          this.themeService.viewPage(result);
          const title =
            (result?.story?.content as any)?.metatags?.title ||
            result.story.name ||
            'All Blogs';
          const description = (result?.story?.content as any)?.metatags
            ?.description;
          return {
            ...result,
            seo: { title, description },
          };
        })
        .catch((err) => this.resolverError.handle(err))),
      articles,
    };
  }
}
